import { useDaily, useMeetingState } from '@daily-co/daily-react'
import { noop } from '@tanstack/react-query'
import { useEffect } from 'react'

export function useEnableKrispNoiseCancellation() {
  const callObject = useDaily()
  const meetingState = useMeetingState()

  useEffect(() => {
    if (!callObject) return

    const enableKrispNoiseCancellation = () => {
      // re-apply if the mic device changes
      callObject.updateInputSettings({ audio: { processor: { type: 'noise-cancellation' } } }).catch(noop)
    }
    // enable after join (calls before join are ignored by Daily)
    if (meetingState === 'joined-meeting') enableKrispNoiseCancellation()

    callObject.on('selected-devices-updated', enableKrispNoiseCancellation)
    return () => {
      callObject.off('selected-devices-updated', enableKrispNoiseCancellation)
    }
  }, [callObject, meetingState])
}
